module.exports = __webpack_public_path__ + "img/cb78ecf0c38e440dbad13d81d96cf136-1440.673d952e.jpg";